/* ---------- CP-002's surge protection earthed to a bar of its own (#3779) ----------
 * -FA1's earth went straight to the earthing busbar's eighth clamp, half a metre away on rail 4. It now goes to -WE2, a small bar
 * right beside -FA1, and -WE2 is bonded to -WE1's eighth clamp (wiring.ts). A save made since #3716 may hold the old conductor,
 * -WE1:8 to -FA1:PE, which the wiring step would now call wrong. How such a save is read: the save migration in packages/progress
 * uses this (format 36). Self-contained on purpose, as tb1earth.ts: the migration imports this file alone, not CP-002's pack. */

/** The conductor that goes: -FA1's earth straight to the earthing busbar's eighth clamp. */
export const CP002_SPD_EARTH_OLD: [string, string] = ["WE1:8", "FA1:PE"];
const isOld = (a: unknown, b: unknown) => (a === CP002_SPD_EARTH_OLD[0] && b === CP002_SPD_EARTH_OLD[1]) || (a === CP002_SPD_EARTH_OLD[1] && b === CP002_SPD_EARTH_OLD[0]);

/** A build record without the old conductor: -WE2 is new work, to place beside -FA1 and wire (its two conductors). */
const one = <A extends { ui?: any }>(s: A): A => {
  const b = s?.ui?.build, wires: any[] = Array.isArray(b?.wires) ? b.wires : [];
  const next = wires.filter(w => !isOld(w?.from, w?.to));
  return next.length === wires.length ? s : { ...s, ui: { ...s.ui, build: { ...b, wires: next } } };
};
/** A saved CP-002 project with -FA1's old earth conductor taken off: its own work and each earlier attempt it keeps. */
export function spdBarCp002Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
